import { createContext } from 'react'
import { type ContextType } from '../lib/types'

const GeContext = createContext<{ value: ContextType | null }>({ value: null })

export default GeContext
